export let accessModuleList = {
    id: 0,
    module_id: 0,
    has_sub_menu: false,
    parent_menu_id: 0,
    can_view: true,
    can_add: true,
    can_edit: true,
    can_delete: true,
    allow_limited_list_view: false,
    allow_full_data_search: false,
    require_approval_when_appropriate: false,
    require_approval_when_appropriate_from_user_group_id: false
}

export let dataProps = {
    id: 0,
    group_name: '',
    get_daily_sale_alert: false,
    get_daily_inventory_re_order_level_alert: false,
    get_customer_balance: false,
    get_next_days_promise: false,
    get_database_backup_15_day: false,
    get_document_expiry_reminder: false,
    get_leave_application_alert: false,
    get_purchase_order_approval_request_alert: false,
    get_stock_check_list_approval_alert: false,
    get_vendor_payment_reminder: false,
    override_sales_discount: false,
    redeem_sale_discount_coupon: false,
    enable_sale_delivery_on_partial_payment: false,
    can_view_cost_sheet: false,
    email_master_data: false,
    hide_inventory_cost_price: false,
    can_approve_purchase_request: false,
    get_stock_alert: false,
    daily_inventory_re_order_level_alert_stores: [],
    
    access_module_list: [],
    temp_access_module_list: [],
}


// WEBPACK FOOTER //
// ./src/store/modules/userGroup/properties.js